/**
 * Positionering van de zoekmodal.
 *
 * De modal moet exact onder de kop van de pagina beginnen: op desktop onder
 * de header (de zoekbalk zit daarbinnen), op mobiel onder de zoekbalk (die
 * steekt eronder uit). Vandaar Math.max van beide onderkanten.
 *
 * WAAROM DIT EEN APART BESTAND IS EN NIET DRIE REGELS
 *
 * extenders-search-bar.js zet bij het openen zelf een inline top op de
 * modal — gemeten op 113px terwijl de header op 62px eindigt, wat een gat
 * van 51px gaf. Dat gebeurt ná ons script, dus we moeten erop reageren.
 *
 * Twee dingen die daarbij misgingen en nu zijn opgelost:
 *
 * 1. De MutationObserver keek naar aria-hidden en class, niet naar style.
 *    De overschrijving werd dus niet opgemerkt.
 *
 * 2. Er stond een lastTop-vergelijking die een herberekening oversloeg als
 *    de gewenste waarde al eerder was gezet. Nadat search-bar.js de waarde
 *    overschreef, dacht het script dat 62 al stond en deed niets.
 *
 * Nu wordt de werkelijke inline waarde uitgelezen en vergeleken. Dat
 * voorkomt ook een oneindige lus: schrijven we niets, dan vuurt de observer
 * ook niet.
 *
 * Een derde valkuil die hier eerder zat: een controle die de meting
 * oversloeg zolang de modal onzichtbaar was. Tijdens de openingsovergang is
 * de opacity nog 0, dus die controle blokkeerde precies het moment waarop
 * het moest gebeuren. Een verborgen modal positioneren kost niets.
 *
 * LET OP HET !IMPORTANT: search-modal.liquid zet top met !important als
 * beginwaarde. Een gewone inline style verliest daarvan, vandaar
 * setProperty met de derde parameter.
 */
(function () {
  'use strict';

  var modal = document.getElementById('search-modal');
  if (!modal) return;

  var input = document.querySelector('.search-bar__input');
  var bar = input ? input.closest('.search-bar') : document.querySelector('.search-bar');
  var header = document.querySelector('.header') || document.getElementById('shopify-section-header');

  var pending = false;

  function desiredTop() {
    var bottom = 0;
    if (header) bottom = Math.max(bottom, header.getBoundingClientRect().bottom);
    if (bar) bottom = Math.max(bottom, bar.getBoundingClientRect().bottom);
    bottom = Math.round(bottom);
    return bottom < 0 ? 0 : bottom;
  }

  function place() {
    var want = desiredTop() + 'px';
    /* Vergelijk met wat er daadwerkelijk staat, niet met wat wij de vorige
       keer schreven — search-bar.js kan het tussendoor overschrijven. */
    if (modal.style.top === want) return;
    modal.style.setProperty('top', want, 'important');
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      place();
    });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);

  if (input) {
    input.addEventListener('focus', schedule);
    input.addEventListener('click', schedule);
    input.addEventListener('input', schedule);
  }

  /* style meekijken is essentieel: daar zit de overschrijving. */
  new MutationObserver(schedule).observe(modal, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'class', 'style']
  });

  /* De header verschuift wanneer de announcement bar wordt weggeklikt. */
  var announcement = document.querySelector('.announcement-bar');
  if (announcement) {
    new MutationObserver(schedule).observe(announcement, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  schedule();

  /* Header en announcement bar kunnen na het laden nog van hoogte
     veranderen (fonts, sliders, app-embeds). */
  [100, 300, 800, 1500].forEach(function (ms) {
    setTimeout(schedule, ms);
  });
})();
